module.exports = __webpack_public_path__ + "static/media/ask-nearspace.c6f58d91.jpg";